var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9115 4.56417L14.3414 19.9512C14.3317 20.2152 14.0991 20.4389 13.834 20.4389H3.9877C3.72284 20.4389 3.48997 20.2144 3.48031 19.9512L2.91024 4.56417C2.89457 4.13962 2.53764 3.80822 2.11309 3.82388C1.68854 3.83977 1.35714 4.19648 1.3728 4.62104L1.94265 20.0081C1.98321 21.0982 2.89519 21.9774 3.98768 21.9774H13.834C14.926 21.9774 15.8384 21.0997 15.879 20.0081L16.4489 4.62104C16.4645 4.19649 16.1331 3.83976 15.7086 3.82388C15.284 3.80821 14.9271 4.13961 14.9114 4.56417H14.9115Z",
    fill: "#dc3545"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29581 7.66969V18.1314C8.29581 18.4714 8.57118 18.7467 8.91115 18.7467C9.25111 18.7467 9.52648 18.4714 9.52648 18.1314V7.66969C9.52648 7.32971 9.25111 7.05435 8.91115 7.05435C8.57118 7.05435 8.29581 7.32972 8.29581 7.66969Z",
    fill: "#dc3545"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91054 7.68777L5.21833 18.1495C5.22842 18.4892 5.51173 18.7567 5.85147 18.7466C6.19123 18.7367 6.45868 18.4532 6.44857 18.1134L6.14078 7.65173C6.13091 7.31196 5.84738 7.04452 5.50764 7.05463C5.16788 7.0645 4.90065 7.34803 4.91054 7.68777Z",
    fill: "#dc3545"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6806 7.65156L11.3728 18.1133C11.3627 18.453 11.6301 18.7366 11.9699 18.7464C12.3096 18.7565 12.593 18.4891 12.603 18.1493L12.9108 7.6876C12.9207 7.34784 12.6535 7.0643 12.3137 7.05446C11.9739 7.04437 11.6904 7.31181 11.6806 7.65156Z",
    fill: "#dc3545"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.21846 4.90041H16.6033C17.0281 4.90041 17.3726 4.55614 17.3726 4.13117C17.3726 3.70641 17.0281 3.36192 16.6033 3.36192H1.21846C0.793702 3.36192 0.449219 3.70641 0.449219 4.13117C0.449219 4.55614 0.793702 4.90041 1.21846 4.90041Z",
    fill: "#dc3545"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57354 3.88117L6.89377 2.75994C6.96245 2.51998 7.27367 2.28517 7.52372 2.28517H10.2981C10.5481 2.28517 10.8593 2.51976 10.928 2.75994L11.2482 3.88117L12.7275 3.45834L12.4073 2.33733C12.1497 1.43649 11.2349 0.746704 10.2981 0.746704H7.52372C6.58684 0.746704 5.67188 1.43677 5.41451 2.33733L5.09428 3.45834L6.57354 3.88117Z",
    fill: "#dc3545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBtn);
export default __webpack_public_path__ + "static/media/delete-btn.9e68261bff7ec7f71806cb4890e898e8.svg";
export { ForwardRef as ReactComponent };